exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-icon-plus[data-v-2b6eeeaf]{margin-right:5px}.demo .el-switch__label[data-v-2b6eeeaf]{position:absolute;display:none;color:#fff}.demo .el-switch__label--right[data-v-2b6eeeaf]{z-index:1}.demo .el-switch__label--left[data-v-2b6eeeaf]{z-index:1;left:19px}.demo .el-switch__label.is-active[data-v-2b6eeeaf]{display:block}.demo.el-switch .el-switch__core[data-v-2b6eeeaf],.el-switch .el-switch__label[data-v-2b6eeeaf]{width:60px !important}", ""]);

// exports
